function init_faq_blok() {
    $faq_blokken = $('.faq-blok__single');

    if($faq_blokken.length) {
        $('.faq-blok__single__vraag').on('click', function() {
            $(this).parent().toggleClass('faq-open');
        });
    }
}

$(document).ready(function() {
    init_faq_blok();
});